document.addEventListener("DOMContentLoaded", function () {
  jQuery(document).ready(function ($) {
    // Function to handle like notifications
    function handleLikeNotification(text) {
      var $notification = $("<div id='like-notification'></div>").text(text);
      $("body").append($notification);
      setTimeout(() => $notification.addClass("active"), 100);
      setTimeout(() => $notification.removeClass("active"), 1800);
      setTimeout(() => $notification.remove(), 2000);
    }

    // Like logic for a discussion
    $("#like-topic").on("click", function (e) {
      e.preventDefault();
      var $this = $(this);
      var currentText = $this.text();
      var newText =
        currentText === "Leuk vinden" ? "Niet meer leuk vinden" : "Leuk vinden";
      var post_id = $this.data("post-id");
      var nonce = $this.data("nonce");
      var likesCounter = document.getElementById("bs-likes-counter");
      var currentLikes = parseInt(likesCounter.textContent, 10);
      var likeToggle = $("#like-toggle");

      $.ajax({
        type: "POST",
        url: "/wp-admin/admin-ajax.php",
        data: {
          action: "update_like_user_meta",
          post_id: post_id,
          security: nonce,
        },
        success: function () {
          // $this.text(newText);
          currentLikes += newText === "Niet meer leuk vinden" ? 1 : -1;
          currentLikes = Math.max(0, currentLikes);
          likesCounter.textContent =
            currentLikes + (currentLikes === 1 ? " Like" : " Likes");

          if (likeToggle.hasClass("liked")) {
            likeToggle.removeClass("liked");
            newTextNotification = "Je vindt deze discussie niet meer leuk";
          } else {
            likeToggle.addClass("liked");
            newTextNotification = "Je vindt deze discussie leuk";
          }

          handleLikeNotification(newTextNotification);
        },
        error: function () {
          console.error("There was an error. Please try again.");
        },
      });
    });

    // Like logic for replies
    $(document).on("click", "[id^='like-reply-']", function (e) {
      e.preventDefault();
      var $this = $(this);
      var post_id = $this.data("post-id");
      var nonce = $this.data("nonce");
      var containerId = "post-" + post_id;
      var container = document.getElementById(containerId);

      if (!container) {
        console.error(`Container for post_id ${post_id} not found.`);
        return;
      }
      var list_item = container.querySelector("#bbp-like-reply-list-item");
      var likesCounter = container.querySelector("#like_count");

      $.ajax({
        type: "POST",
        url: "/wp-admin/admin-ajax.php",
        data: {
          action: "update_like_user_meta_replies",
          post_id: post_id,
          security: nonce,
        },
        success: function () {
          var currentLikes = parseInt(likesCounter.textContent, 10);
          var TextNotification;
          if (list_item.classList.contains("liked")) {
            list_item.classList.remove("liked");
            currentLikes = Math.max(0, currentLikes - 1);
            TextNotification = "Je vindt deze reactie niet meer leuk";
          } else {
            list_item.classList.add("liked");
            currentLikes += 1;
            TextNotification = "Je vindt deze reactie leuk";
          }
          likesCounter.textContent =
            currentLikes + (currentLikes === 1 ? " like" : " likes");
          handleLikeNotification(TextNotification);
        },
        error: function () {
          console.error("There was an error. Please try again.");
        },
      });
    });
  });
});
